/** @module csi/table/ToolbarSwitchBoardTable */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/def",
	"csi/def/Action",
	"csi/page/SearchManager",
	"csi/table/Widget",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml",
	"csi/xml/Query"
], function(declare, _, def, Action, SearchManager, Table, ToolbarPluginSwitchboard, xml, Query) {

	return declare(Table, {
		// this is purely a selection view, so no need to include action context
		prefViewContext: "",

		/** @property {string} attributeName - name of attribute used on secondary types to load the Attribute Name field */
		attributeName: null,

		/** @property {Query} [containerQuery] - extra query filters to apply to owners */
		//containerQuery: null,

		/** @property {string} containerSourceType - type of container that opened the view which will affect custom view to select by default when opening view */
		containerSourceType: null,

		/** @property {string} [containerSourceUrl] - url of container that opened the view which will be filtered out if source and target types match */
		//containerSourceUrl: null,

		/** @property {string} switchboardTargetType - the type selected in the switchboard, usually the same as containerTargetType but can be overriden */
		switchboardTargetType: null,

		/** @property {string} containerTargetType - type of view */
		containerTargetType: null,

		/** @property {Store} containerTypeStore - store for switchboard drop down */
		containerTypeStore: null,

		/**@property {boolean} selectorOnSecondary - Place switchboard on secondary toolbar */
		selectorOnSecondary: false,

		/**
		 * Add type switchboard to plugin and set default value for container type to select from
		 */
		_resolveView: function() {
			var type = this.containerSourceType;

			// when performing custom view migration and no view node exists, then need to extract type from custom view key
			if (this.customViewMigrationContainerKey && !type) {
				type = def.decomposeViewKey(this.customViewMigrationContainerKey).context;
			}

			this.set("switchboardTargetType", type);

			if (this.containerTypeStore) {
				// this case to handle data store undefined
				var action = _.extend(new Action(), {
					m_id: "SwitchboardType",
					bSecondaryToolbar: this.selectorOnSecondary,
					classToolbarPlugin: ToolbarPluginSwitchboard,
					classToolbarPluginParams: {
						idViewProperty: "switchboardTargetType",
						pageSize: Infinity,
						store: this.containerTypeStore,
						onChangeItem: function() { }
					},
					m_postAction: function(ac) {
						var view = ac.widget;
						view._defaultCustomView = null;
						view.defView.m_headings = null;
						view.sortSettings = null;
						view.resetForm();
						view.refreshAttributes();
						view.refreshDefaultCustomView(true);
					}
				});
				action.resolve();
				this.plugins.push(action);
			}

			this.inherited(arguments);
		},

		_setSwitchboardTargetTypeAttr: function(value) {
			this._set("switchboardTargetType", value);
			this.set("containerTargetType", value);
		},

		/**
		 * Update view to show custom views and nodes of given type
		 * @param {string} value
		 */
		_setContainerTargetTypeAttr: function(value) {
			this._set("containerTargetType", value);

			// reset custom view container key so that custom views are particular to given type
			this.prefKey = this.defView.getKey(value);

			// reset view query to that of new type
			this.relRoot.setType(value);

			// apply default filters for that type from search configuration
			var node = this.getViewNode();
			if (node) {
				var query = new Query();

				if (this.containerSourceUrl && (this.containerSourceType == this.containerTargetType)) {
					query.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, this.containerSourceUrl);
				}

				if (this.containerQuery) {
					query.importQuery(this.containerQuery);
				}

				this.relRoot.addQuery(SearchManager.getSearchTypeQuery(value, query), true);
			}
		}
	});
});